import { render, staticRenderFns } from "./lightbox-manager.vue?vue&type=template&id=1b1f4d7a&"
import script from "./lightbox-manager.vue?vue&type=script&lang=js&"
export * from "./lightbox-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b1f4d7a')) {
      api.createRecord('1b1f4d7a', component.options)
    } else {
      api.reload('1b1f4d7a', component.options)
    }
    module.hot.accept("./lightbox-manager.vue?vue&type=template&id=1b1f4d7a&", function () {
      api.rerender('1b1f4d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/lightbox-manager.vue"
export default component.exports